export default "__VITE_ASSET__EevRkrJA__"